import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { SubscriptionForm } from "../../components/subscriptionForm";

export const SubscriptionPage = () => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);
  return (
    <Elements stripe={stripePromise}>
      <SubscriptionForm />
    </Elements>
  );
};
